// "How to play Drawing Guess" — shown by the screen guide and the VR rules panel.

export const DRAWING_RULES: { title: string; lines: string[] }[] = [
  {
    title: 'The idea',
    lines: [
      '3 to 12 players take turns drawing a secret word on the big easel while everyone else races to guess it.',
      'Walk up and join any time, even mid-game — you get your own turn to draw.',
    ],
  },
  {
    title: 'Your turn to draw',
    lines: [
      'Pick one of three words (you have 15 seconds, or one is picked for you). Only you can see it.',
      'Draw it — no letters or numbers! On screen: draw with the mouse or your finger. In VR: touch the pad in front of you with your fingertip (controllers: hold the trigger on the pad or the easel).',
      'Pick colours and brush sizes, Undo or Clear. Everyone sees your drawing on the easel live.',
    ],
  },
  {
    title: 'Guessing',
    lines: [
      'Type your guess (in VR: the big keyboard on your panel). Capitals, spaces and punctuation don’t matter.',
      'Wrong guesses show in the chat. A right guess shows only "Name guessed it!" — the word stays secret.',
      'If you are very close, only you see "so close!". Letters of the word are revealed as time runs down.',
    ],
  },
  {
    title: 'Scoring',
    lines: [
      'Guess fast: up to 300 points right away, down to 50 at the buzzer.',
      'The drawer gets 50 points for every player who guesses the word.',
      'The turn ends when time is up or everyone has guessed. After 2 or 3 rounds the highest score wins.',
    ],
  },
];
